module.exports = __webpack_public_path__ + "img/pisco-sour.7f4e8e09.jpg";